import {
  createStore,
  applyMiddleware,
  compose,
  type PreloadedState,
  type Store,
} from "redux";
import thunk from "redux-thunk";
import combinedReducers from "./combineReducers";
import type { RegistrationState } from "./reducer";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/** Root Redux state (single `registration` slice). */
export type RootState = { registration: RegistrationState };

/**
 * Partial preloaded state from tests / bootstrapping. Wider than `PreloadedState`
 * so nested `registration` slices type-check; cast is safe for `createStore`.
 */
export function configureStore(
  initialState: Record<string, unknown> = {},
): Store<RootState> {
  return createStore(
    combinedReducers,
    initialState as PreloadedState<RootState>,
    composeEnhancers(applyMiddleware(thunk)),
  );
}
